<div class="card mb-2">
	<div class="row">
		<h2>Cierre de Caja <span style="font-weight: 100;">, {{getTodayDate()}}</span></h2>
	</div>
</div>
<div class="card mb-2" id="closure-data">
	<div class="card-header">
		<h3>1. Datos del cierre</h3>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="form-group">
				<label for="cash">Caja a cerrar
					<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">
						*</span></label>
				<select [class.bg-danger-custom]="!cashClosureRequest.data.idCashier" name="cashier" id="cashier"
					[(ngModel)]="cashClosureRequest.data.idCashier" class="form-select">
					<option *ngIf="!cashClosureRequest.data.idCashier" value="undefined" selected>Seleccione una caja</option>
					<option *ngFor="let cash of cashiers" value="{{cash.id}}">{{cash.name}}</option>
				</select>
			</div>
		</div>
		<div class="row mb-2">
			<span class="title-hr">
				<hr />Saldos
				<hr />
			</span>
			<div class="col-sm form-group">
				<label for="cash">En Caja</label>
				<div class="input-group">
					<label for="" class="input-group-text">Q.</label>
					<input type="number" min="0" [(ngModel)]="cashClosureRequest.data.cash" class="form-control" id="cash"
						name="cash" placeholder="0.00">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="transfer-amount">En Transferencia</label>
				<div class="input-group">
					<label for="" class="input-group-text">Q.</label>
					<input type="number" min="0" [(ngModel)]="cashClosureRequest.data.transfer" class="form-control"
						id="transfer" name="transfer" placeholder="0.00">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="card">En Tarjeta</label>
				<div class="input-group">
					<label for="" class="input-group-text">Q.</label>
					<input type="number" min="0" [(ngModel)]="cashClosureRequest.data.card" class="form-control" id="card"
						name="card" placeholder="0.00">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="check">En Crédito</label>
				<div class="input-group">
					<label for="check" class="input-group-text">Q.</label>
					<input type="number" min="0" [(ngModel)]="cashClosureRequest.data.check" class="form-control" id="check"
						name="check" placeholder="0.00">
				</div>
			</div>
		</div>
	</div>
</div>
<div class="card mb-2" id="transfer-data">
	<div class="card-header">
		<h3>
			2. Carga de fotos de transferencias y visa
		</h3>
	</div>
	<div class="card-body">
		<input type="file" (change)="addPhoto($event)" class="form-control" id="toUpload2" accept="image/*" multiple
			style="display:none;">
		<span class="text-muted"><i class="fa fa-circle-info"></i> Puedes agregar varias imagenes haciendo click o
			arrastrando los archivos al botón </span>
		<div class="album">
			<div (dragleave)="dragging=false" (drop)="addPhotosDrop($event)" (dragover)="allowDrop($event)"
				(click)="addPhotos()" class="card album-item drag-container"
				style="display: flex;justify-content: center; align-items: center; border: 1px dotted gray;">
				<span style="font-size: 2em;"><i [ngClass]="dragging?'fa-upload':'fa-camera'"
						class="fa-solid"></i></span>
				<span>{{dragging?'Carga las fotos':'Agrega fotos'}}</span>
			</div>
			<div class="album-item" *ngFor="let photo of cashClosureRequest.images; let i = index">
				<img class="album-photo" src="{{photo}}">
				<div class="over-image">
					<!-- <i class="fa fa-eye text-info"></i> -->
					<i (click)="deletePhoto(i)" class="fa fa-trash text-danger"></i>
				</div>
			</div>
		</div>
		<div class="buttons">
			<button class="btn btn-danger" type="button"> <i class="fa fa-ban"></i>CANCELAR</button>
			<button class="btn btn-info" type="button" (click)="saveClosure()"
				[disabled]="!cashClosureRequest.data.idCashier || loading">
				<span *ngIf="!loading"><i class="fa fa-floppy-disk"></i>GUARDAR</span>
				<span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span></button>
		</div>
	</div>
</div>
<div class="card" *ngIf="closed">
	<div class="card-header">
		<h3>Resultados del cierre de la caja General, {{getTodayDate()}}</h3>
	</div>
	<div class="card-body">
		<p>Se muestran en color rojo los saldos ingresados por el usuario que no coinciden con el sistema. La caja se
			encuentra
			<b
				style="font-size: 1.2em;">{{balances.total.user==balances.total.system?'balanceada':'desbalanceada'}}.</b>
		</p>
		<table class="table">
			<caption>Comparación de saldos</caption>
			<thead>
				<tr class="tr-column-balance">
					<th>Tipo de Saldo</th>
					<th class="text-center"><i class="fa fa-user"></i>Usuario</th>
					<th class="text-center">Estado</th>
					<th class="text-center"><i class="fa fa-robot"></i>Sistema</th>
				</tr>
			</thead>
			<tbody class="tbody-balance">
				<tr class="{{balances.cash.user==balances.cash.system?'table-info':'table-danger'}}">
					<td><i class="bx bx-money"></i> En caja</td>
					<td class="text-center">{{balances.cash.user}}</td>
					<td class="text-center"><i
							class="fa {{balances.cash.user==balances.cash.system?'fa-check':'fa-x'}}"></i></td>
					<td class="text-center">{{balances.cash.system}}</td>
				</tr>
				<tr class="{{balances.transfer.user==balances.transfer.system?'table-info':'table-danger'}}">
					<td><i class="fa fa-money-check-dollar"></i> En transferencia</td>
					<td class="text-center">{{balances.transfer.user}}</td>
					<td class="text-center"><i
							class="fa {{balances.transfer.user==balances.transfer.system?'fa-check':'fa-x'}}"></i></td>
					<td class="text-center">{{balances.transfer.system}}</td>
				</tr>
				<tr class="{{balances.card.user==balances.card.system?'table-info':'table-danger'}}">
					<td><i class="bx bx-credit-card"></i> En tarjeta</td>
					<td class="text-center">{{balances.card.user}}</td>
					<td class="text-center"><i
							class="fa {{balances.card.user==balances.card.system?'fa-check':'fa-x'}}"></i></td>
					<td class="text-center">{{balances.card.system}}</td>
				</tr>
				<tr class="{{balances.check.user==balances.check.system?'table-info':'table-danger'}}">
					<td><i class="fa fa-money-bill-trend-up"></i> En cheques</td>
					<td class="text-center">{{balances.check.user}}</td>
					<td class="text-center"><i
							class="fa {{balances.check.user==balances.check.system?'fa-check':'fa-x'}}"></i></td>
					<td class="text-center">{{balances.check.system}}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr class="{{balances.total.user==balances.total.system?'table-info':'table-danger'}}">
					<td class="fw-bolder">Total</td>
					<td class="text-center">{{balances.total.user}}</td>
					<td class="text-center"><i
							class="fa {{balances.total.user==balances.total.system?'fa-check':'fa-x'}}"></i></td>
					<td class="text-center">{{balances.total.system}}</td>
				</tr>
			</tfoot>
		</table>
	</div>
</div>